import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CustomConfirmationAlert = ({ 
  isOpen, 
  title, 
  message, 
  primaryButtonText = "OK", 
  secondaryButtonText = "Cancelar", 
  tertiaryButtonText = null,
  onPrimary, 
  onSecondary,
  onTertiary,
  type = "warning" 
}) => {
  if (!isOpen) return null;

  const getBackgroundColor = () => {
    switch (type) {
      case "success": return "bg-green-50";
      case "error": return "bg-red-50";
      case "info": return "bg-blue-50";
      case "warning":
      default: return "bg-amber-50";
    }
  };
  
  const getIconColor = () => {
    switch (type) {
      case "success": return "text-green-500";
      case "error": return "text-red-500";
      case "info": return "text-blue-500";
      case "warning":
      default: return "text-amber-500";
    }
  };

  const getIcon = () => {
    switch (type) {
      case "success": return (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      );
      case "error": return (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      );
      case "info": return (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      );
      case "warning":
      default: return (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      );
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          className={`${getBackgroundColor()} p-6 rounded-lg shadow-xl max-w-lg mx-auto`}
        >
          <div className="flex items-start gap-4">
            <div className={`flex-shrink-0 ${getIconColor()}`}>
              {getIcon()}
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-medium text-gray-900">{title}</h3>
              <p className="mt-2 text-sm text-gray-700">{message}</p>
              <div className="mt-4 flex flex-nowrap justify-end gap-2 sm:flex-nowrap">
  <button
    type="button"
    onClick={onSecondary}
    className="w-[100px] px-4 py-1 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
  >
    {secondaryButtonText}
  </button>

  {tertiaryButtonText && (
    <button
      type="button"
      onClick={onTertiary}
      className="px-4 py-1 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
    >
      {tertiaryButtonText}
    </button>
  )}

  <button
    type="button"
    onClick={onPrimary}
    className="px-4 py-1 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
  >
    {primaryButtonText}
  </button>
</div>



            </div>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default CustomConfirmationAlert;